import { NextErrorsPanel } from 'components/shared/ErrorsPanel/NextErrorsPanel';
import type { IntlKey } from 'locales';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { IRegulatoryRejection } from 'state/regulatoryDocuments';

export interface DocumentErrorListProps {
  rejections: IRegulatoryRejection[];
  containerId: string;
  isInternal: boolean;
  titleIntKey?: IntlKey;
}

export const DocumentListError: FC<DocumentErrorListProps> = ({ rejections, containerId }) => {
  return (
    <ul className="alert alert-discreet-danger text-valencia m-0" data-e2e={containerId}>
      {rejections.map((rejection, index) => {
        return (
          <li className="list-group-item border-light" key={index}>
            <span className="p-0 m-0">
              <i className="icon icon-sm text-socgen pe-2">cancel</i>
              {rejection.rejectionMessage ?? rejection.originMessage}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
export const DocumentRejectionErrorPanel: FC<DocumentErrorListProps> = ({
  containerId,
  rejections,
  isInternal,
  titleIntKey,
}) => {
  const { formatMessage } = useIntl();

  const toWorkflowError = (regulatoryRejection: IRegulatoryRejection): NextWorkflowError =>
    regulatoryRejection as NextWorkflowError;

  const errors = rejections?.map(toWorkflowError);

  return (
    <div className="w-100 alert d-flex mx-2 mb-2 px-0 alert-discreet-danger text-danger">
      <div className="card-body px-4 py-2">
        <NextErrorsPanel
          id={containerId}
          standardErrorMessage={!isInternal && titleIntKey ? titleIntKey : undefined}
          defaultErrorMessage={formatMessage({ id: 'unknownErrorContactSale' })}
          workflowErrors={errors || []}
          layout={isInternal ? 'summaryAndDetails' : 'summaryOnly'}
          shouldUseRejectionCode={false}
        />
      </div>
    </div>
  );
};
